'use strict';

import ScoreGraph from './score_graph';

$(function() {
  // overview
  if ($('#profile-stats-anime-overview-dist').length) {
    const score = new ScoreGraph('profile-stats-anime-overview-dist', [
      {label: 'Completed', value: 'completed', color: '#26448f'},
    ], [], 'anime');
    score.renderOverviewGraph();
  }
  if ($('#profile-stats-manga-overview-dist').length) {
    const score = new ScoreGraph('profile-stats-manga-overview-dist', [
      {label: 'Completed', value: 'completed', color: '#26448f'},
    ], [], 'manga');
    score.renderOverviewGraph();
  }

  // score
  if ($('#profile-stats-anime-score-dist').length) {
    const score = new ScoreGraph('profile-stats-anime-score-dist', [
      {label: 'Completed', value: 'completed', color: '#26448f'},
      {label: 'Watching', value: 'watching', color: '#2db039'},
      {label: 'On Hold', value: 'on_hold', color: '#f9d457'},
      {label: 'Dropped', value: 'dropped', color: '#a12f31'},
    ], [
      {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
      {key: 'statuses', value: 'completed', label: 'Completed', type: 'check', position: 'filter'},
      {key: 'dated_at', value: 'season', label: 'This Season', type: 'check', position: 'mal_filter'},
      {key: 'dated_at', value: 'last_season', label: 'Last Season', type: 'check', position: 'mal_filter'},
      {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'mal_filter'},
      {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'mal_filter'},
    ], 'anime');
    score.renderScoreGraph();
  }
  if ($('#profile-stats-manga-score-dist').length) {
    const score = new ScoreGraph('profile-stats-manga-score-dist', [
      {label: 'Completed', value: 'completed', color: '#26448f'},
      {label: 'Reading', value: 'reading', color: '#2db039'},
      {label: 'On Hold', value: 'on_hold', color: '#f9d457'},
      {label: 'Dropped', value: 'dropped', color: '#a12f31'},
    ], [
      {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
      {key: 'statuses', value: 'completed', label: 'Completed', type: 'check', position: 'filter'},
      {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'mal_filter'},
      {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'mal_filter'},
    ], 'manga');
    score.renderScoreGraph();
  }
});
